"use strict";

import angular from "angular";

import template from "./account-parameterization.component.html";
import "./themes/account-parameterization-dark.component.scss";
import "./themes/account-parameterization.component.scss";

import _ from "lodash";
import { Serie } from "../../../gateway/Serie/Serie";
import { DepartmentTaxAndPersonnel } from "../../../presentation/services/DepartmentTaxAndPersonnel/DepartmentTaxAndPersonnel";
import { FakeLoadingManager } from "../../../presentation/services/FakeLoadingManager/FakeLoadingManager";
import { NormalizeString } from "../../../utils/normalize-string/NormalizeString";
class AccountParameterizationComponent {
    constructor($scope, LoaderService, DSNDialogService) {
        this.$scope = $scope;
        this.LoaderService = LoaderService;
        this.DSNDialogService = DSNDialogService;
        this.Serie = new Serie();
        this.FakeLoadingManager = new FakeLoadingManager({
            config: "parametrization_edit"
        });
        this.DepartmentTaxAndPersonnel = new DepartmentTaxAndPersonnel({
            Serie: this.Serie
        });
        this.showAccounts = true;
        this.seriesFrom = [];
        this.opened = [];
        this.mainSeries = [];
        this.associateds = [];
        this.allOpened = false;
        this.hasChanges = false;
        this.searchTerm = "";
        this.selectedAccounts = [];
        this.selectedItem = "";
        this.searchText = "";
        this.currentAccounts = [];
        this.searchTextAccount = "";
        this.filterAccountsActive = "";
        this.seriesMapDisabled = {};
        this.filtersLabels = {
            parameterizeds: "Parametrizadas",
            "not-parameterizeds": "Não Parametrizadas"
        };
    }
    $onInit() {
        this.seriesFrom = this.FakeLoadingManager.generate();
        this.onViewInit();
    }
    async onViewInit() {
        this.loading = true;
        this.LoaderService.setProgress(true);
        this.setSeriesMapDisabled(this.seriesTo);
        await this._setSeriesFrom();
        this._setMainSeries();
        this._setAssociateds();
        this._setCurrentAccounts();
        this.opened = angular.copy(this.mainSeries);
        this.LoaderService.setProgress(false);
        this.loading = false;
        this.$scope.$applyAsync();
    }
    toggleAccounts() {
        this.showAccounts = !this.showAccounts;
    }
    async _setSeriesFrom() {
        const series = await this.Serie.getByCompanyIdSources({
            companyId: this.companyData._id,
            sources: "financial"
        });
        const isNibo = this.companyData?.relation?.nibo ? true : false;
        if (isNibo) {
            this.seriesFrom = series;
        } else {
            this.seriesFrom = this.DepartmentTaxAndPersonnel.organizeBreno(
                series
            );
        }
    }

    setSeriesMapDisabled(series) {
        this.seriesMapDisabled = {};
        for (const serie of series) {
            if (!serie.compound?.length) continue;
            const hasEnabledInCompound = serie.compound.some((compoundId) => {
                const s = series.find((x) => x._id === compoundId);
                return s && !s.metadata?.disabled;
            });
            if (hasEnabledInCompound) {
                this.seriesMapDisabled[serie._id] = true;
            }
        }
    }

    open(serie, all) {
        if (all) {
            this.allOpened = true;
            this.opened = this.seriesFrom.map((s) => s._id);
            return;
        }
        this.opened = this.opened.concat(serie.compound);
    }
    hide(serie, all) {
        if (all) {
            this.allOpened = false;
            this.opened = this.mainSeries;
            return;
        }
        this.opened = _.difference(
            this.opened,
            this.Serie.getParent(serie._id, this.seriesFrom)
        );
        this.allOpened = false;
    }
    _setMainSeries() {
        this.mainSeries = this.seriesFrom
            .filter((s) => s.level == 0)
            .map((s) => s._id);
    }
    isOpened(serieId) {
        return this.opened.includes(serieId);
    }
    onFilterSeries = (item) => {
        const name = _.deburr(`${item.classifier} ${item.name}`).toUpperCase();
        const search = _.deburr(this.searchTerm).toUpperCase();

        return name.includes(search);
    };
    clearSearchTerm() {
        this.searchTerm = "";
    }

    onSave() {
        const associateds = this._formatToSave();
        this.save({ associateds });
    }

    _formatToSave(associateds = this.associateds) {
        const _associateds = angular.copy(associateds);

        _associateds.forEach((a) => {
            a.associated = a.associated.map((s) => s._id);
        });

        return _associateds;
    }

    onCancel() {
        if (!this.hasChanges) return this.cancel();

        this.DSNDialogService.confirmation({
            locals: {
                destructive: true,
                title: "Tem certeza que deseja cancelar?",
                destructive: true,
                description:
                    "Se você cancelar, perderá todas as alterações realizadas.",
                actions: {
                    confirm: {
                        label: "Cancelar",
                        action: () => {
                            this.cancel();
                            this.DSNDialogService.hide();
                        }
                    },
                    cancel: {
                        label: "Voltar",
                        action: () => {
                            this.DSNDialogService.cancel();
                        }
                    }
                }
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    }

    onCheck(serie) {
        this.hasChanges = true;

        const associated = this.associateds.findIndex((a) => {
            return this.currentSerie._id === a._id;
        });

        if (
            associated > -1 &&
            this.associateds[associated].associated.find(
                (s) => s._id === serie._id
            )
        )
            _.remove(
                this.associateds[associated].associated,
                (a) => a._id === serie._id
            );
        else {
            if (associated > -1)
                this.associateds[associated].associated.push({
                    _id: serie._id,
                    name: serie.name,
                    classifier: serie.classifier
                });
            else
                this.associateds.push({
                    _id: this.currentSerie._id,
                    associated: [
                        {
                            _id: serie._id,
                            name: serie.name,
                            classifier: serie.classifier
                        }
                    ]
                });
        }

        this._setCurrentAccounts();
    }

    onFilterList = (serie) => {
        const searchTerm = NormalizeString.formatNameNdSearch(
            this.searchTextAccount
        );
        const serieName = NormalizeString.formatNameNdSearch(serie.name);
        if (!this.filterAccountsActive) {
            if (!this.searchTextAccount) return true;
            return serieName.includes(searchTerm);
        } else {
            const filters = {
                parameterizeds: () => {
                    const isChecked = this.isChecked(serie);
                    if (!this.searchTextAccount) return isChecked;
                    return serieName.includes(searchTerm) && isChecked;
                },
                "not-parameterizeds": () => {
                    const isNotAssociated = this.isNotAssociatedInAnySerie(
                        serie
                    );
                    if (!this.searchTextAccount) return isNotAssociated;
                    return serieName.includes(searchTerm) && isNotAssociated;
                }
            };
            if (filters[this.filterAccountsActive])
                return filters[this.filterAccountsActive]();
            else return true;
        }
    };

    isNotAssociatedInAnySerie(serie) {
        const associatedInAnySerie = this.associateds.filter((associated) => {
            if (
                associated?.associated?.length > -1 &&
                associated?.associated.find((s) => s._id === serie._id)
            )
                return true;
            else return false;
        });
        if (associatedInAnySerie.length) return false;
        return true;
    }

    onFilterAccounts(filter) {
        if (this.filterAccountsActive === filter)
            this.filterAccountsActive = "";
        else {
            this.filterAccountsActive = filter;
            this.open({}, true);
        }
    }

    onClearFilters() {
        this.filterAccountsActive = "";
        this.searchTextAccount = "";
    }

    onChangeSearchAccount() {
        this.open({}, true);
    }

    isChecked(serie) {
        const associated = this.associateds.findIndex((a) => {
            return this.currentSerie._id === a._id;
        });

        if (
            associated > -1 &&
            this.associateds[associated].associated.find(
                (s) => s._id === serie._id
            )
        )
            return true;
        else return false;
    }

    onSelectSerieTo(serie) {
        if (this.seriesMapDisabled[serie._id]) return;
        this.currentSerie = serie;
        this._setCurrentAccounts();
    }

    getCountParameterizeds(serie) {
        const serieTo = this.associateds.find((a) => {
            return serie._id === a._id;
        });

        if (serieTo) return serieTo.associated.length;

        return 0;
    }

    /**
     * Return the proper object when the append is called.
     */
    transformChip(chip) {
        // If it is an object, it's already a known chip
        if (angular.isObject(chip)) {
            return chip;
        }

        // Otherwise, create a new one
        return { name: chip, type: "new" };
    }

    querySearch(text) {
        return this.seriesFrom.filter((serie) => {
            const name = _.deburr(
                `${serie.classifier} ${serie.name}`
            ).toUpperCase();
            const search = _.deburr(text).toUpperCase();

            return name.includes(search);
        });
    }

    _setCurrentAccounts(serie = this.currentSerie) {
        const associated = this.associateds.find((a) => a._id === serie._id);

        if (associated) this.currentAccounts = associated.associated;
        else this.currentAccounts = [];
    }

    _setAssociateds() {
        const associateds = [];

        for (const serie of this.seriesTo) {
            if (_.get(serie, "parametrizeIds.length")) {
                const parameterizedSeries = serie.parametrizeIds.map((s) => {
                    const serieFrom = this.seriesFrom.find(
                        (sf) => sf._id === s
                    );

                    if (!serieFrom) return {};

                    return {
                        _id: serieFrom._id,
                        name: serieFrom.name,
                        classifier: serieFrom.classifier
                    };
                });

                associateds.push({
                    _id: serie._id,
                    associated: parameterizedSeries
                });
            }
        }

        this.associateds = associateds;
    }

    onSelectAccount() {
        this.hasChanges = true;
    }
}

export { AccountParameterizationComponent };

AccountParameterizationComponent.$inject = [
    "$scope",
    "LoaderService",
    "DSNDialogService"
];

const name = "accountParameterizationComponent";
const def = {
    bindings: {
        seriesTo: "<",
        source: "@",
        companyData: "<",
        currentSerie: "<",
        save: "&",
        cancel: "&",
        loading: "="
    },
    controller: AccountParameterizationComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
